export default "__VITE_ASSET__DoASXd_p__"